import { createApp } from 'vue';
import App from './app.vue';
import './assets/styles.css';

createApp(App).mount('#app');
